import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../components/Button'
import '../assets/languages/i18n'
import { Box, Grid, Link, Paper, TextField, Toolbar, Typography, InputAdornment, Alert, Collapse } from "@mui/material";
import { Formik } from "formik";
import LoginBG from "../../src/assets/images/bg.svg"
import LoginLogo1 from "../../src/assets/images/login/design-stats-pana-2.png"
import MailSend from "../../src/assets/images/login/email-send.png"
import { fetchStartParam } from "../actions/start";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../services/auth.service";
import { useCookies } from 'react-cookie';
import { makeStyles } from "@mui/styles";

const styles = {
    toolBar: {
        paddingLeft: "5px",
    },
    childToolBar: {
        padding: "32px 20px",
        fontWeight: '400'
    },
    title: {
        paddingBottom: "15px"
    },
    subTitle: {
        color: "#282C40 !important"
    },
};

const useStyles = makeStyles({
    error: {
        color: " #CC6058 !important",
        "& div > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& div > input": {
            fontSize: "14px",
            lineHeight: "15.4px",
        },
        "& div > label": {
            color: "#0C2B34",
            fontSize: "16px",
            lineHeight: "17.6px",
            fontWeight: "500"
        },
    },
});

const ForgetView = () => {
    // getData();
    const [cookies, setCookie] = useCookies(['member']);
    const classes = useStyles()
    const navigate = useNavigate();
    const { t } = useTranslation()
    let { site } = useParams()
    const dispatch = useDispatch();
    const Start = {
        data: {
            configuration: {
                username: 'emails',
                maintenance: false,
            }
        }
    };//useSelector((state) => state.Start);
    // Start?.data?.configuration?.username === 'emails'
    const vBackLogin = '/nida'//Start?.data?.configuration?.forget_password ? JSON.parse(Start.data.configuration.forget_password).value : "";
    useEffect(() => {
        var getSite = localStorage.getItem("site")
        dispatch(fetchStartParam(getSite ? getSite : "iamconsulting"))
    }, []);
    const [showPassword, setShowPassword] = useState(false);
    const [sendedMail, setSendedMail] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const handleClick = () => {
        setShowPassword(prev => !prev);
    }

    /*** control logic  */
    console.log('start = ', Start)

    return (
        <>
            <Helmet>
                <title>Forget Password | PMS</title>
            </Helmet>
            {/*<Box height={1} sx={{}}>*/}
            <Grid container sx={{
                height: '100%',
                'backgroundImage': `url(${LoginBG})`,
                'background-size': 'cover'
            }}>
                <Grid container item
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        alignItems: 'center',
                        overflow: 'hidden',
                        boxShadow: 0,
                        fontWeight: 'bold',
                    }}>
                    <Grid container item xs={12} lg={6} justifyContent="center"
                        sx={{ display: { sm: 'none', lg: 'flex' } }} alignItems="center">
                        <img src={LoginLogo1} />
                    </Grid>
                    <Grid container item xs={12} lg={4} spacing={4} sx={{}}>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item sx={{}}>
                                <Paper elevation={6} sx={{ padding: '50px', 'border-radius': '20px' }} classes={{ root: classes.error }}>
                                    <Formik
                                        // initialValues={{
                                        //     username: 'chorchujai.san@nida.ac.th',
                                        //     password: 'Chorchujai00'
                                        // }}

                                        initialValues={{
                                            username: '',
                                        }}
                                        validationSchema={Yup.object().shape(
                                            Start?.data?.configuration?.username === 'emails' ?
                                                {
                                                    username: Yup.string()
                                                        .email(t('login.msg.wrongusername'))
                                                        .required(t('login.msg.specify_username')),
                                                }
                                                :
                                                {
                                                    username: Yup.string()
                                                        .required(t('login.msg.specify_username')),
                                                }
                                        )}
                                        onSubmit={(values, { setSubmitting, setErrors, setStatus, resetForm }) => {
                                            if (sendedMail) {
                                                navigate('/nida')
                                            } else {
                                                console.log('sendMail')
                                                setSendedMail(true)
                                            }
                                            // AuthService.login(
                                            //     values.username,
                                            //     values.password).then(
                                            //         (response) => {
                                            //             setCookie('member', response.data.data);
                                            //             if (response.data.data.consent === true) {
                                            //                 navigate('/kpi/home', { replace: false });
                                            //             } else {
                                            //                 navigate('/consent', { replace: false });
                                            //             }
                                            //         },
                                            //         (response) => {

                                            //             setStatus({ success: false })
                                            //             setSubmitting(false)

                                            //             // const vErrorUser = "login.msg.user_not_found_in_pms"
                                            //             // const vErrorPass = "login.msg.cannot_login_ad"

                                            //             const vErrorUser = "login.msg.wrongemail"
                                            //             const vErrorPass = "login.msg.wrongpassword"

                                            //             if (response?.data?.message?.code?.Code === vErrorUser) {

                                            //                 setErrors({
                                            //                     username: t('login.msg.user_not_found_in_pms'),
                                            //                 })
                                            //             }
                                            //             if (response?.data?.message?.code?.Code === vErrorPass) {

                                            //                 setErrors({
                                            //                     password: t('login.msg.cannot_login_ad')
                                            //                 })
                                            //             }


                                            //         }
                                            //     )
                                        }}
                                    >
                                        {({
                                            errors,
                                            handleBlur,
                                            handleChange,
                                            handleSubmit,
                                            isSubmitting,
                                            touched,
                                            values
                                        }) => (
                                            <form onSubmit={handleSubmit} sx={{
                                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                                            }}>
                                                {sendedMail
                                                    ?
                                                    <Grid container>
                                                        <Box sx={{ mb: 3 }}>
                                                            <Grid container item justifyContent="center">
                                                                <img style={{ width: '40%', height: '40%' }} src={MailSend} />
                                                            </Grid>
                                                            <Typography
                                                                color="primary"
                                                                variant="h2"
                                                                style={styles.title}
                                                                fontSize={36}
                                                                lineHeight="39.6px"
                                                            >
                                                                {t('login.label.checkMail')}

                                                            </Typography>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h2"
                                                                style={styles.subTitle}
                                                                fontSize={16}
                                                                fontWeight={300}
                                                                lineHeight="17.6px"
                                                            >
                                                                {t('login.label.checkMailDesc')}
                                                            </Typography>
                                                        </Box>
                                                        <Grid item xs sx={{ marginTop: '30px' }}>
                                                            <Button
                                                                color="primary"
                                                                fullWidth
                                                                size="large"
                                                                type="submit"
                                                                variant="contained"
                                                            >
                                                                {t('consent.label.backToLogin')}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid>
                                                        <Box sx={{ mb: 3 }}>
                                                            <Typography
                                                                color="primary"
                                                                variant="h2"
                                                                style={styles.title}
                                                                fontSize={36}
                                                                lineHeight="39.6px"
                                                            >
                                                                {t('login.label.changePassword')}

                                                            </Typography>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h2"
                                                                style={styles.subTitle}
                                                                fontSize={16}
                                                                fontWeight={300}
                                                                lineHeight="17.6px"
                                                            >
                                                                {t('login.label.changePasswordDesc')}
                                                            </Typography>
                                                        </Box>
                                                        <TextField
                                                            error={Boolean(touched.username && errors.username)}
                                                            fullWidth
                                                            helperText={touched.username && errors.username}
                                                            label={t("login.label.email")}
                                                            margin="normal"
                                                            name="username"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            type="email"
                                                            value={values.username}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            placeholder={t('login.label.holderUsername')}
                                                        />
                                                        <Grid item xs sx={{ marginTop: '30px' }}>
                                                            <Button
                                                                color="primary"
                                                                disabled={isSubmitting}
                                                                fullWidth
                                                                size="large"
                                                                type="submit"
                                                                variant="contained"
                                                            >
                                                                {t('label.confirm')}
                                                            </Button>
                                                        </Grid>
                                                        <Grid container direction={"row"} sx={{ justifyContent: 'center' }}>
                                                            <Grid item pb={2} pt={2}>
                                                                <Typography fontSize={14} lineHeight="15.4px" fontWeight={500}>
                                                                    <Link color="textSecondary" href={vBackLogin}>
                                                                        {t('consent.label.backToLogin')}
                                                                    </Link>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </form>
                                        )}
                                    </Formik>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/*footer*/}
                <Grid container item sx={{
                    bottom: 0
                }}
                >
                    <Toolbar color="primary" sx={{ 'align-items': 'end', 'padding-left': '5px' }} style={styles.toolBar}>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Privacy Policy
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Terms of Service
                        </Typography>
                    </Toolbar>
                </Grid>
            </Grid>
            {/*</Box>*/}
        </>
    );
};
export default ForgetView;
